import type TUser from "@kamae-apps/shared/Types/TUser"
import { userService } from "../../Services/UserServices"

export async function fetchUserData(): Promise<TUser> {
  return userService.fetchUserData()
}

export async function fetchUserV1Data(): Promise<TUser> {
  return userService.fetchUserV1Data()
}

export async function updateUserData(body: TUser): Promise<TUser> {
  return userService.updateUserData(body)
}
